import { ApolloClient, InMemoryCache } from '@apollo/client/core'

const cache = new InMemoryCache()

export const apolloClient = new ApolloClient({
  cache,
  uri: process.env.VUE_APP_API_URL_GRAPHQL,
})
